import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicAqiMapDashboardComponent } from './public-aqi-map-dashboard/public-aqi-map-dashboard.component';
import { AgmCoreModule } from '@agm/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedFilterModalModule } from 'src/app/shared/shared-filter-modal/shared-filter-modal.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'src/app/shared/table/table.module';
import { TimeAgoPipe } from 'time-ago-pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { AgmOverlays } from 'agm-overlays';
import { MapWindroseLoaderComponent } from './map-windrose-loader/map-windrose-loader.component';
import { MapAnalyticLoaderComponent } from './map-analytic-loader/map-analytic-loader.component';
import { MapMunicipalDashboardLoaderComponent } from './map-municipal-dashboard-loader/map-municipal-dashboard-loader.component';
import { MapStaionViewLoaderComponent } from './map-staion-view-loader/map-staion-view-loader.component';
import { MapLiveStatusLoaderComponent } from './map-live-status-loader/map-live-status-loader.component';
import { AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';



@NgModule({
  declarations: [
    PublicAqiMapDashboardComponent,
    MapWindroseLoaderComponent,
    MapAnalyticLoaderComponent,
    MapMunicipalDashboardLoaderComponent,
    MapStaionViewLoaderComponent,
    MapLiveStatusLoaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedFilterModalModule,
    NgSelectModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDcvCXAmyYViB3YXDefistdzGptHilc5pI'
    }),
    FormsModule,
    TableModule,
    NgbModule,
    DataTablesModule,
    AgmOverlays,
    AgmJsMarkerClustererModule
  ],
  exports: [
    PublicAqiMapDashboardComponent,
    MapWindroseLoaderComponent,
    MapAnalyticLoaderComponent,
    MapMunicipalDashboardLoaderComponent,
    MapStaionViewLoaderComponent,
    MapLiveStatusLoaderComponent
  ]
})
export class MapLoaderModule { }
